import { ModalFilter } from '../../types';

import { ReturnedAction } from '../reduxTypes';

export const setSavedMarketFilters = (value: Array<ModalFilter | null>): ReturnedAction => ({
  type: 'SET_SAVED_MARKET_FILTERS',
  value
});
